(function ($) {
  var ready = $.fn.ready;
  $.fn.ready = function (fn) {
    var selector = this.selector || null;
    var context = this.context || document;
    
    if (!selector) {
      // No selector, just call ready normally
      ready(fn);
    } else {
      // Selector provided, wait for ready then apply to matching elements
      ready(function() {
        $(selector, context).each(fn);
      });
    }
    
    return this;
  }
})(jQuery);